import * as React from "react";
import { RadiosEditor } from "../../../../react-core/Html/RadiosEditor";
import { DistributionDividendPreference } from "../../../../Wrap/Constants/Enums/Domain/DistributionDividendPreference";
import { UserClaim } from "../../../../Wrap/Constants/Enums/UserClaim";
import { SectionHeader } from "../../../Dashboard/Components/Clients/NewBusinessWizard/Components/SharedComponents";
import { checkPermission } from "../../Permission/PermissionHelper";
import { IProcessComponentProps, ProcessComponent } from "../../Process/Process/ProcessComponent";
import { manageIncomeOptionsMap, ProcessType } from "../Resource/Content";
import { SubAccountType } from "../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { SubAccountTypeHelper } from "../../../Dashboard/Components/Clients/Common/Helpers/SubAccountTypeHelper";

interface IManageIncomeProps extends IProcessComponentProps {
    type: ProcessType;
    clAccountId: string;
    product:SubAccountType;
}

interface IManageIncomeState {}

export class ManageIncome extends ProcessComponent<IManageIncomeProps, IManageIncomeState> {
    constructor(props: IManageIncomeProps) {
        super(props);
        this.state = {};
    }

    isValid(): boolean {
        let distributionDividendPreference = this.props.data?.DistributionDividendPreference ?? DistributionDividendPreference.NotSpecified;
        if (distributionDividendPreference == DistributionDividendPreference.NotSpecified){
            this.props.onChange({ DistributionDividendPreference: DistributionDividendPreference.ProductCash });
        }
        return true;
    }

    render() {
        const { type, onChange, data } = this.props;
        return (
            <>
                {SectionHeader("Manage investment income")}
                <RadiosEditor
                    cssWrapper="control-size-430 mb-30 rg-inline"
                    selected={this.props.data?.DistributionDividendPreference}
                    options={Object.keys(manageIncomeOptionsMap).map((ele) => Number(ele))}
                    onChange={(v) => onChange({ DistributionDividendPreference: v })}
                    required={"Please select"}
                    getText={(v) =>
                        v === DistributionDividendPreference.ProductCash &&
                        SubAccountTypeHelper.isJSIPP(this.props.product)
                            ? "Leave as cash in Aberdeen JSIPP"
                            : manageIncomeOptionsMap[v]
                    }
                />
                {this.props.clAccountId && checkPermission(UserClaim.AdviserPortalDluManageIncomeCanView) && (
                    <a href={"/clients/cash/manageincome.aspx?claccountid=" + this.props.clAccountId} target="_blank">
                        Edit income options
                    </a>
                )}
            </>
        );
    }
}
